import { defineMessages } from 'react-intl';

export default defineMessages({
  head: {
    id: 'components.languageSuggest.head',
    defaultMessage: 'We speak your language',
  },
  body: {
    id: 'components.languageSuggest.body',
    defaultMessage:
      'The Native Instruments website is also available in your language.',
  },
  linkText: {
    id: 'components.languageSuggest.linkText',
    defaultMessage: 'Change language',
  },
});
